export type MetricThreshold = {
  target: number;
  warn: number;
  direction: 'higherBetter' | 'lowerBetter';
  enabled?: boolean;
  targetUnit?: string;
  warnUnit?: string;
};

export const DISABLED_HIGHER_BETTER_THRESHOLD_VALUE = 0;
export const DISABLED_LOWER_BETTER_THRESHOLD_VALUE = 999999999;

export const isMetricThresholdDisabled = (threshold: MetricThreshold): boolean => {
  if (threshold.enabled === false) return true;
  if (threshold.direction === 'higherBetter') {
    return (
      threshold.target === DISABLED_HIGHER_BETTER_THRESHOLD_VALUE &&
      threshold.warn === DISABLED_HIGHER_BETTER_THRESHOLD_VALUE
    );
  }
  return (
    threshold.target === DISABLED_LOWER_BETTER_THRESHOLD_VALUE &&
    threshold.warn === DISABLED_LOWER_BETTER_THRESHOLD_VALUE
  );
};

export const metricThresholdsSuites: Record<
  'passRate' | 'frequency' | 'flakeScore' | 'greenTime' | 'mttf' | 'avgDuration',
  MetricThreshold
> = {
  passRate: { target: 90, warn: 75, direction: 'higherBetter' },
  frequency: {
    target: 0.42857142857142855,
    warn: 0.14285714285714285,
    direction: 'higherBetter',
    targetUnit: 'weeks',
    warnUnit: 'weeks',
  },
  flakeScore: { target: 10, warn: 25, direction: 'lowerBetter' },
  greenTime: { target: 3, warn: 1, direction: 'higherBetter' },
  mttf: { target: 1, warn: 3, direction: 'lowerBetter' },
  avgDuration: {
    target: 300,
    warn: 600,
    direction: 'lowerBetter',
    targetUnit: 'minutes',
    warnUnit: 'minutes',
  },
};

export const metricThresholdsTests: Record<
  'passRate' | 'frequency' | 'flakeScore' | 'greenTime' | 'mttf' | 'avgDuration',
  MetricThreshold
> = {
  passRate: { target: 90, warn: 75, direction: 'higherBetter' },
  frequency: {
    target: 0.42857142857142855,
    warn: 0.14285714285714285,
    direction: 'higherBetter',
    targetUnit: 'weeks',
    warnUnit: 'weeks',
  },
  flakeScore: { target: 5, warn: 25, direction: 'lowerBetter' },
  greenTime: { target: 3, warn: 1, direction: 'higherBetter' },
  mttf: { target: 1, warn: 3, direction: 'lowerBetter' },
  avgDuration: {
    target: 120,
    warn: 300,
    direction: 'lowerBetter',
    targetUnit: 'minutes',
    warnUnit: 'minutes',
  },
};

export const metricThresholdsPipelines: Record<
  'passRate' | 'frequency' | 'flakeScore' | 'greenTime' | 'mttf' | 'avgDuration',
  MetricThreshold
> = {
  passRate: { target: 90, warn: 75, direction: 'higherBetter' },
  frequency: {
    target: 0.2857142857142857,
    warn: 0.14285714285714285,
    direction: 'higherBetter',
    targetUnit: 'weeks',
    warnUnit: 'weeks',
  },
  flakeScore: { target: 25, warn: 50, direction: 'lowerBetter' },
  greenTime: { target: 3, warn: 1, direction: 'higherBetter' },
  mttf: { target: 1, warn: 3, direction: 'lowerBetter' },
  avgDuration: {
    target: 900,
    warn: 1200,
    direction: 'lowerBetter',
    targetUnit: 'minutes',
    warnUnit: 'minutes',
  },
};

export const metricThresholdsExecutionRuns: Record<
  'passRate' | 'frequency' | 'flakeScore' | 'greenTime' | 'mttf' | 'avgDuration',
  MetricThreshold
> = {
  passRate: { target: 90, warn: 75, direction: 'higherBetter' },
  frequency: {
    target: 0.42857142857142855,
    warn: 0.14285714285714285,
    direction: 'higherBetter',
    targetUnit: 'weeks',
    warnUnit: 'weeks',
  },
  flakeScore: { target: 10, warn: 25, direction: 'lowerBetter' },
  greenTime: { target: 3, warn: 1, direction: 'higherBetter' },
  mttf: { target: 1, warn: 3, direction: 'lowerBetter' },
  avgDuration: {
    target: 600,
    warn: 900,
    direction: 'lowerBetter',
    targetUnit: 'minutes',
    warnUnit: 'minutes',
  },
};

export const metricThresholds = metricThresholdsSuites;
